<template>
  <content-editor
    permission="page"
    :fields="fields"
    @update="updateState"
    :publication="true"
    :hasAuthor="false"
    previewModule="page"
    endpoint="page"
    module="page">
  </content-editor>
</template>

<script>
import ContentEditor from '@/components/editor/content_blocks/ContentEditor.vue';
import ContentDetail from '@/mixins/contentEditor/Detail';

export default {
  mixins: [ContentDetail],
  components: {
    ContentEditor,
  },
  data() {
    return {
      module: 'page',
      fields: [
        {
          name: 'notes',
          required: false,
        },
        {
          name: 'name',
          required: true,
        },
        {
          name: 'url',
          required: true,
        },
        {
          name: 'status',
          required: true,
        },
        {
          name: 'parentPage',
          required: false,
        },
        {
          name: 'internal',
          required: true,
        },
      ],
    };
  },
};
</script>
